import React from 'react';
import { css } from '@linaria/core';
import { classnames } from '../../utils';
/**
 * Styles which visually hide an element but it remains
 * readable to screen readers.
 * This matches the styles which tailwind use to provide
 * better integration to `not-sr-only` class
 *
 * https://tailwindcss.com/docs/screen-readers
 */
export const screenReaderOnlyStyles = css `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
`;
/**
 * Visually hide content that can be still read by a screen reader
 */
export const ScreenReaderOnly = ({ children, className, ...props }) => {
    return (React.createElement("span", { ...props, className: classnames(screenReaderOnlyStyles, className) }, children));
};


import "../../../css/atoms/ScreenReaderOnly/ScreenReaderOnly.css";
